export const MAIN_SEARCH_TRANSFER_TEST_IDS = {
  // ─── Transfer Search Form ───
  formContainer: 'main-search-transfer-form-container',

  // ─── Trip Type / Passengers ───
  tripTypeSelect: 'main-search-transfer-trip-type-select',
  passengersSelect: 'main-search-transfer-passengers-select',

  // ─── Form Fields ───
  departureSelect: 'main-search-transfer-departure-select',
  destinationSelect: 'main-search-transfer-destination-select',
  pickUpDate: 'main-search-transfer-pickup-date',
  dropOffDate: 'main-search-transfer-dropoff-date',
  pickUpTime: 'main-search-transfer-pickup-time',
  dropOffTime: 'main-search-transfer-dropoff-time',

  // ─── Actions ───
  searchButton: 'main-search-transfer-search-btn',
  managedByLabel: 'main-search-transfer-managed-by-label',
  managedByIcon: 'main-search-transfer-managed-by-icon',
} as const;
